import React from "react";
import { Copy, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function DkTahkimModal({ paket, onClose, onPdf }) {
    if (!paket) return null;

    const metin = paket.metin || "";
    const brifing = paket.savunma_brifing?.metin || "";
    const saglik = paket.dosya_saglik;

    const kopyala = async () => {
        if (!metin) return;
        try {
            await navigator.clipboard.writeText(metin);
            toast.success("Tahkim paketi kopyalandı");
        } catch {
            toast.error("Kopyalanamadı");
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
            <div className="w-full max-w-2xl max-h-[85vh] rounded-2xl border border-amber-500/30 bg-[#0c1222] shadow-2xl flex flex-col">
                <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
                    <div>
                        <h3 className="text-white font-medium">Tahkim savunma paketi</h3>
                        <p className="text-xs text-slate-500 mt-0.5">{paket.dosya_no}</p>
                    </div>
                    <button type="button" onClick={onClose} className="text-slate-400 hover:text-white">
                        <X className="h-5 w-5" />
                    </button>
                </div>
                <div className="overflow-y-auto p-5 space-y-4 text-sm">
                    {saglik ? (
                        <div className="rounded-lg border border-amber-500/20 bg-amber-500/5 px-4 py-3">
                            Dosya sağlık:{" "}
                            <span className="text-amber-200 font-medium">
                                {saglik.skor}/100 · {saglik.durum}
                            </span>
                        </div>
                    ) : null}
                    {metin ? (
                        <pre className="text-xs text-slate-300 whitespace-pre-wrap bg-black/30 rounded-xl p-4 border border-white/5">
                            {metin}
                        </pre>
                    ) : null}
                    {brifing ? (
                        <div>
                            <div className="text-[10px] uppercase text-slate-500 mb-2">Savunma brifingi</div>
                            <p className="text-xs text-slate-400 whitespace-pre-wrap">{brifing.slice(0, 3000)}</p>
                        </div>
                    ) : null}
                    <p className="text-[10px] text-slate-600 leading-relaxed">
                        Yargıtay içtihatları çerçevesinde değer kaybı tazminatı talep edilebilir; somut olayın
                        kusur, hasar ve rayiç koşulları sonucu değiştirebilir.
                    </p>
                </div>
                <div className="flex flex-wrap gap-2 px-5 py-4 border-t border-white/10">
                    <Button size="sm" variant="outline" onClick={kopyala}>
                        <Copy className="h-4 w-4 mr-1" />
                        Kopyala
                    </Button>
                    {onPdf ? (
                        <Button size="sm" className="bg-amber-600 hover:bg-amber-500" onClick={onPdf}>
                            Tahkim PDF
                        </Button>
                    ) : null}
                    <Button size="sm" variant="ghost" onClick={onClose}>
                        Kapat
                    </Button>
                </div>
            </div>
        </div>
    );
}
